import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTurbine = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 70,
	height: 100,
	viewBox: "0 0 70.0 100.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 35.0 L 60.0 0.0 L 60.0 100.0 L 0.0 65.0 Z M 70.0 50.0 L 60.0 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgTurbine;
